import { useMutation, UseMutationResult } from 'react-query';
import type { ResponseFormat } from '../algebra/global';

import { Http } from '../prelude/http';

export const useCreateWebchat = (): UseMutationResult<string, unknown, {messaging_service_key:string}, unknown> => {
  return useMutation(({messaging_service_key}) => Http.AwsWafIntegrationRequest<ResponseFormat<string>>('POST', `/hotlines/api/v1/ingress/webchats.create?messaging_service_key=${messaging_service_key}`).then((res) => res.data));
};

// export const useCreateWebchatUsaid = (): UseMutationResult<string, unknown, { key: string }, unknown> => {
//   return useMutation(({ key }) => Http.AwsWafIntegrationRequest<ResponseFormat<string>>('POST', `/hotlines/api/v1/ingress/webchats.create?messaging_service_key=${key}`).then((res) => res.data));
// };
